import React from 'react';
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import logo from "../images/logo_001.png"
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas  } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from 'axios';
import config from '../config'
import '../styles/layout.css';

library.add(fas)

class AppNavbar extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.state = {
      isOpen: false,
      email: '',
    };
  }

  componentDidMount = () => {
    this.checkSession()
    this.feedAccount()
  }

  toggle() {
    this.setState({ isOpen: !this.state.isOpen })
  }

  closeMenu() {
    this.setState({ isOpen: false })
  }

  checkSession = () => {
    if (!localStorage.StudioUserID) {
      window.location.assign("/");
    }
  }

  Logout = () => {
    axios.post(config.host + '/api/v1/auth/logout').then(res => {
      localStorage.StudioUserToken = ''
      localStorage.StudioUserID = ''
      this.checkSession()
    }).catch(err => {})
  }

  feedAccount = () => {
    axios.post(config.host + '/api/v1/account', {
      id: localStorage.StudioUserID
    }).then(res => {
      this.setState({ email: res.data.result[0].email })
    }).catch(err => {})
  }

  render() {
    const { isOpen, email } = this.state;

    return (
      <Navbar className="studio-navbar" color="light" light expand="md">
        <div className="studio-navbar__inner">
          <NavbarBrand tag={Link} to="/home" onClick={this.closeMenu}>
            <img src={logo} alt="i-IPTV Studio Portal" />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={isOpen} navbar>
            <Nav className="mr-auto" navbar>
            <NavItem>
              <NavLink
                tag={RouterNavLink}
                to="/home"
                exact
                activeClassName="active-nav"
                onClick={this.closeMenu}
              >
                <FontAwesomeIcon icon={['fas', 'home']} />
                Home
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                tag={RouterNavLink}
                to="/live-streams"
                activeClassName="active-nav"
                isActive={(match, location) =>
                  Boolean(match) || location.pathname.startsWith('/studio')
                }
                onClick={this.closeMenu}
              >
                <FontAwesomeIcon icon={['fas', 'video']} />
                Live Streams
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                tag={RouterNavLink}
                to="/videos"
                activeClassName="active-nav"
                onClick={this.closeMenu}
              >
                <FontAwesomeIcon icon={['fas', 'play-circle']} />
                Videos
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                tag={RouterNavLink}
                to="/monitoring"
                activeClassName="active-nav"
                onClick={this.closeMenu}
              >
                <FontAwesomeIcon icon={['fas', 'chart-line']} />
                Monitoring
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                tag={RouterNavLink}
                to="/analytic/view/insights"
                activeClassName="active-nav"
                onClick={this.closeMenu}
              >
                <FontAwesomeIcon icon={['fas', 'chart-pie']} />
                View Insights
              </NavLink>
            </NavItem>
            </Nav>
            <UncontrolledDropdown setActiveFromChild>
              <DropdownToggle tag="a" className="nav-link studio-user-menu" caret>
                <span className="studio-user-avatar">
                  <FontAwesomeIcon icon={['fas', 'user']} />
                </span>
                <span>{email}</span>
              </DropdownToggle>
              <DropdownMenu className="drop-profile" end>
                <DropdownItem tag={Link} to="/profile" onClick={this.closeMenu}>
                  Profile
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={this.Logout}>Logout</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Collapse>
        </div>
      </Navbar>
    );
  }
}

export default AppNavbar;
